import React from 'react';
import {
  withRouter, Switch, Route, Redirect,
} from 'react-router-dom';
import { connect } from 'react-redux';
import Admin from './Admin';
import Quiz from './Quiz';
import QuizSection from './QuizSection';
import SplashScreen from './SplashScreen';
import Question from './Question';
import Questions from './QuizQuestions';
import Loading from './Loading';
import ErrorMessage from './ErrorMessage';
import QuizHeader from './QuizHeader';
import {
  adminAreaLoaded,
  getQuizID,
  getAnswers,
  getUserUID,
  getFilteredUserUIDs,
  totalNumberQuestions,
  currentUserNumberQuestionsAnswered,
  currentUserNumberQuestionsAnsweredIncorrectly,
  currentUserNumberQuestionsAnsweredCorrectly,
} from '../selectors';
import SubaruLogo from '../images/Subaru_logo.svg';
import '../styles/App.css';

const App = ({
  dispatch,
  fetchedSite,
  fetchSiteError,
  checkedAuth,
  loggedIn,
  totalQuestions,
  userUID,
  users,
  fetchedAnswers,
  adminAreaLoaded,
  numberOfQuestionsAnswered,
}) => {
  if (!fetchedSite || !checkedAuth || !fetchedAnswers) {
    if (fetchSiteError === true) {
      return <ErrorMessage>Site Unavailable. Check your connection</ErrorMessage>;
    }
    return <Loading />;
  }

  return (
    <div className="App">
      <Route path="/quiz" component={QuizHeader} />
      <Route path="/admin" exact component={QuizHeader} />
      <Switch>
        <Route path="/" exact component={SplashScreen} />
        <Route path="/signup" exact component={SplashScreen} />
        <Route path="/signin" exact component={SplashScreen} />
        <Route path="/forgot-password" exact component={SplashScreen} />
        {!loggedIn && <Redirect to="/signin" />}
        {(loggedIn) && (
          <Route render={() => (
            <div className="main pt5">
              <Route path="/admin" exact component={Admin} />
              <Route path="/quiz" exact component={Quiz} />
              <Route path="/quiz/survey" exact component={Quiz} />
              <Route path="/questions" exact component={Questions} />
              <Route path="/quiz/:quizSection" exact component={QuizSection} />
              <Route path="/quiz/:quizSection/:questionID" exact component={Question} />
              <div className="pv3 mw-100 mw7-ns w-100 bg-white center tc"><img alt="Subaru" src={SubaruLogo} className="w-40 w-20-ns center" /></div>
            </div>
          )}
          />
        )}
      </Switch>
    </div>
  );
};

function mapStateToProps(state, ownProps) {
  return {
    loggedIn: state.loggedIn,
    checkedAuth: state.checkedAuth,
    quizID: getQuizID(state),
    userUID: getUserUID(state),
    users: getFilteredUserUIDs(state, ownProps),
    fetchedAnswers: state.fetchedAnswers,
    fetchedSite: state.fetchedSite,
    fetchingSite: state.fetchingSite,
    fetchSiteError: state.fetchSiteError,
    answers: getAnswers(state),
    adminAreaLoaded: adminAreaLoaded(state, ownProps),
    totalQuestions: totalNumberQuestions(state),
    numberOfQuestionsAnswered: currentUserNumberQuestionsAnswered(state, ownProps),
    numIncorrect: currentUserNumberQuestionsAnsweredIncorrectly(state),
    numCorrect: currentUserNumberQuestionsAnsweredCorrectly(state),
  };
}

export default withRouter(connect(mapStateToProps)(App));



// WEBPACK FOOTER //
// ./src/components/App.js